import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AuthService } from './auth.service';
import { Version } from '../_models/version';
import { EnvironmentalData } from '../_models/environmentalData';
import { TunnelingEnvironmentalData } from '../_models/tunnelingEnvironmentalData';

@Injectable({
  providedIn: 'root'
})
export class EnvironmentalDataService {
  constructor(
    private http: HttpClient,
    private authService: AuthService
  ) {}

  getIndustryFuelEnvironmentalData(resourceId: string, versionId?: string) {
    let params = new HttpParams();
    params = versionId ? params.set('versionId', versionId) : params;
    params = params.set('type', 'IndustryFuel');

    return this.http.get<EnvironmentalData>(`${environment.apiUrl}/EnvironmentalData/${resourceId}`, {
      params: params,
      headers: this.authService.headers
    });
  }

  getTransportationFuelEnvironmentalData(resourceId: string, versionId?: string) {
    let params = new HttpParams();
    params = versionId ? params.set('versionId', versionId) : params;
    params = params.set('type', 'TransportationFuel');

    return this.http.get<EnvironmentalData>(`${environment.apiUrl}/EnvironmentalData/${resourceId}`, {
      params: params,
      headers: this.authService.headers
    });
  }

  getVehicleEnvironmentalData(resourceId: string, versionId?: string) {
    let params = new HttpParams();
    params = versionId ? params.set('versionId', versionId) : params;
    params = params.set('type', 'Vehicle');

    return this.http.get<EnvironmentalData>(`${environment.apiUrl}/EnvironmentalData/${resourceId}`, {
      params: params,
      headers: this.authService.headers
    });
  }

  getTunnelerEnvironmentalData(versionId?: string) {
    let params = new HttpParams();
    params = versionId ? params.set('versionId', versionId) : params;

    return this.http.get<TunnelingEnvironmentalData>(`${environment.apiUrl}/EnvironmentalData/tunnelerEF`, {
      params: params,
      headers: this.authService.headers
    });
  }

  //   getAll() {
  //     return this.http.get<Version[]>(`${environment.apiUrl}/Versions`, { headers: this.authService.headers });
  //   }
}
